import { addAuthorizationToHeaders } from "./CommonService"
import noRefreshClient from "./api/NoRefreshClient"
import refreshClient, { handleErrors } from "./api/RefreshClient"

export async function getUserById(userId) {
    return addAuthorizationToHeaders({})
            .then(async headers => {
                return refreshClient.get("users/" + userId, {headers})
                        .then(data => data.data)
                        .catch(async error => handleErrors(error)
                                    // Handle response as usual if we got response from the retried request
                                    .then(data => data.data)
                                    .catch(error => Promise.reject(error))
                        )
            })
}

export async function logoutUser() {
    return noRefreshClient.post('logout')
            .then(data => data)
            .catch(error => Promise.reject(error))
}